(() => {
  'use strict';

  if(window.ELEVENINE_PRICE_SYNC_READY)return;
  window.ELEVENINE_PRICE_SYNC_READY=true;

  const store=window.ELEVENINE_SHOPIFY_STORE||{};
  const currency=String(store.currency||'MXN').toUpperCase();
  const locale='es-MX';
  const handles=window.ELEVENINE_PRODUCT_HANDLES||{};
  const productMap=window.ELEVENINE_SHOPIFY_PRODUCTS||window.ELEVENINE_NATIVE_CATALOG||{};
  const requestCache=new Map();

  const normalize=value=>String(value??'')
    .trim()
    .toLocaleLowerCase('es-MX')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .replace('blanco/naranja','blanco/rojo');

  const optionNames=product=>(product?.options||[]).map(option=>
    typeof option==='string'?option:(option?.name||'')
  );

  const hasPositiveShopifyPrice=product=>Array.isArray(product?.variants)&&product.variants.some(variant=>Number(variant.price)>0);

  const matchingVariants=(product,selections={})=>{
    const variants=Array.isArray(product?.variants)?product.variants:[];
    const names=optionNames(product);
    const selected=Object.entries(selections).filter(([,value])=>String(value||'').trim());
    if(!selected.length)return variants;
    const matches=variants.filter(variant=>selected.every(([label,value])=>{
      const index=names.findIndex(name=>normalize(name)===normalize(label));
      return index<0||normalize(variant.options?.[index])===normalize(value);
    }));
    return matches.length?matches:variants;
  };

  const priceBounds=(product,selections={})=>{
    const prices=matchingVariants(product,selections)
      .map(variant=>Number(variant.price))
      .filter(Number.isFinite);
    if(!prices.length){
      const minimum=Number(product?.price_min);
      const maximum=Number(product?.price_max);
      if(!Number.isFinite(minimum))return null;
      return {min:minimum,max:Number.isFinite(maximum)?maximum:minimum};
    }
    return {min:Math.min(...prices),max:Math.max(...prices)};
  };

  const catalogPrice=bounds=>{
    if(!bounds)return null;
    const minimum=bounds.min/100;
    const maximum=bounds.max/100;
    return minimum===maximum?minimum:[minimum,maximum];
  };

  const formatter=new Intl.NumberFormat(locale,{
    style:'currency',
    currency,
    currencyDisplay:'narrowSymbol',
    minimumFractionDigits:2,
    maximumFractionDigits:2
  });
  const labelForBounds=bounds=>{
    if(!bounds)return'PRECIO POR CONFIRMAR';
    const minimum=formatter.format(bounds.min/100);
    const maximum=formatter.format(bounds.max/100);
    return `${bounds.min===bounds.max?minimum:`${minimum} – ${maximum}`} ${currency}`;
  };
  const labelForStartingBounds=bounds=>{
    if(!bounds)return'PRECIO POR CONFIRMAR';
    const minimum=formatter.format(bounds.min/100);
    return `${bounds.min===bounds.max?minimum:`Desde ${minimum}`} ${currency}`;
  };
  const setTextIfChanged=(node,label)=>{
    if(!node||node.textContent.trim()===label)return false;
    node.textContent=label;
    return true;
  };

  const descriptionText=nativeProduct=>{
    const source=String(nativeProduct?.description||nativeProduct?.body_html||'').trim();
    if(!source)return'';
    const container=document.createElement('div');
    container.innerHTML=source;
    return String(container.textContent||container.innerText||'')
      .replace(/\s+/g,' ')
      .trim();
  };

  const descriptionExcerpt=text=>{
    if(text.length<=220)return text;
    const sentence=text.slice(0,221).match(/^(.{50,220}?[.!?])(?:\s|$)/)?.[1];
    if(sentence)return sentence;
    return text.slice(0,217).replace(/\s+\S*$/,'').trim()+'…';
  };

  const setCatalogDescription=(item,nativeProduct)=>{
    if(!item||!nativeProduct)return;
    const description=descriptionText(nativeProduct);
    if(!description)return;
    item.shopifyDescription=description;
    item.shopifyShortDescription=descriptionExcerpt(description);
  };

  const selectionsForModel=model=>/^\d{4}$/.test(String(model||''))?{Modelo:String(model)}:{};

  const itemCategory=item=>item?.category||item?.cat||'';
  const isSurronComingSoon=(item,model)=>itemCategory(item)==='SUR-RON'&&(
    (/^\d{4}$/.test(String(model||''))&&Number(model)>=2026)
    ||(!model&&Number(item?.year??item?.y)>=2026)
  );
  const isSurronLaunch=(item,model)=>itemCategory(item)==='SUR-RON'&&(
    item?.launch||String(model||'')==='nuevo-lanzamiento'
  );

  const labelForCatalogPrice=price=>{
    if(price==null)return'PRECIO POR CONFIRMAR';
    const values=(Array.isArray(price)?price:[price]).map(Number).filter(value=>Number.isFinite(value)&&value>0);
    if(!values.length)return'PRECIO POR CONFIRMAR';
    const minimum=Math.min(...values),maximum=Math.max(...values);
    return `${minimum===maximum?formatter.format(minimum):`${formatter.format(minimum)} – ${formatter.format(maximum)}`} ${currency}`;
  };

  const setCatalogPrice=(item,nativeProduct,selections={})=>{
    if(!item||!nativeProduct||!hasPositiveShopifyPrice(nativeProduct))return;
    const hasModelOption=optionNames(nativeProduct).some(name=>normalize(name)==='modelo');
    if(itemCategory(item)==='SUR-RON'&&hasModelOption&&!selections.Modelo)return;
    const bounds=priceBounds(nativeProduct,selections);
    if(bounds&&bounds.max>0)item.price=catalogPrice(bounds);
  };

  const handleFromHref=href=>{
    try{
      const parts=new URL(href,location.origin).pathname.split('/').filter(Boolean);
      const index=parts.indexOf('products');
      return index>=0?decodeURIComponent(parts[index+1]||''):'';
    }catch{return''}
  };

  const fetchProduct=handle=>{
    if(!handle)return Promise.resolve(null);
    if(productMap[handle])return Promise.resolve(productMap[handle]);
    if(window.ELEVENINE_NATIVE_PRODUCT?.handle===handle)return Promise.resolve(window.ELEVENINE_NATIVE_PRODUCT);
    if(!requestCache.has(handle)){
      requestCache.set(handle,fetch(`/products/${encodeURIComponent(handle)}.js`,{
        headers:{Accept:'application/json'},
        credentials:'same-origin'
      }).then(response=>response.ok?response.json():null).catch(()=>null));
    }
    return requestCache.get(handle);
  };

  const allCatalogItems=()=>{
    const items=[];
    try{if(typeof P!=='undefined'&&Array.isArray(P))items.push(...P)}catch{}
    const catalog=window.ELEVENINE_CATALOG;
    if(Array.isArray(catalog?.allProducts))items.push(...catalog.allProducts);
    else if(Array.isArray(catalog?.products))items.push(...catalog.products);
    return [...new Set(items)];
  };

  const hydrateCatalogData=()=>{
    const currentModel=new URLSearchParams(location.search).get('modelo');
    allCatalogItems().forEach(item=>{
      const handle=handles[String(item.id)]||item.slug;
      const nativeProduct=productMap[handle]
        ||(window.ELEVENINE_NATIVE_PRODUCT?.handle===handle?window.ELEVENINE_NATIVE_PRODUCT:null);
      const selections=window.ELEVENINE_NATIVE_PRODUCT?.handle===handle
        ?selectionsForModel(currentModel)
        :{};
      if(nativeProduct){
        setCatalogDescription(item,nativeProduct);
        if(hasPositiveShopifyPrice(nativeProduct)){item.quoteOnly=false;setCatalogPrice(item,nativeProduct,selections);}
      }
      else fetchProduct(handle).then(product=>{
        setCatalogDescription(item,product);
        if(hasPositiveShopifyPrice(product)){item.quoteOnly=false;setCatalogPrice(item,product,selections);}
        scheduleSync();
      });
    });
  };

  const catalogItemById=id=>{
    try{
      if(typeof P!=='undefined'&&Array.isArray(P)){
        const item=P.find(product=>Number(product.id)===Number(id));
        if(item)return item;
      }
    }catch{}
    return window.ELEVENINE_CATALOG?.byId?.(id)||null;
  };

  const syncCard=card=>{
    const id=Number(card.dataset.productId);
    const item=catalogItemById(id);
    if(!id||[27,28,29].includes(id))return;
    const handle=handles[String(id)]||item?.slug;
    const apply=nativeProduct=>{
      if(!nativeProduct)return;
      const model=String(card.dataset.modelo||'').trim();
      const bounds=priceBounds(nativeProduct,selectionsForModel(model));
      const isModelLocked=/^\d{4}$/.test(model);
      const label=bounds&&bounds.max>0
        ?(isModelLocked?labelForBounds(bounds):labelForStartingBounds(bounds))
        :labelForCatalogPrice(item?.price);
      card.querySelectorAll('.pr,.surron-model-price,.price-tag').forEach(node=>{
        setTextIfChanged(node,label);
      });
    };
    const immediate=productMap[handle]||(window.ELEVENINE_NATIVE_PRODUCT?.handle===handle?window.ELEVENINE_NATIVE_PRODUCT:null);
    if(immediate)apply(immediate);
    else fetchProduct(handle).then(apply);
  };

  const syncRelatedCard=card=>{
    const handle=handleFromHref(card.getAttribute('href'));
    const item=window.ELEVENINE_CATALOG?.bySlug?.(handle);
    const priceNode=card.querySelector(':scope>b');
    if(!handle||!priceNode||item?.category==='STARK VARG')return;
    fetchProduct(handle).then(product=>{
      const label=labelForBounds(priceBounds(product));
      setTextIfChanged(priceNode,label);
    });
  };

  const syncComparator=()=>{
    const table=document.getElementById('compTable');
    if(!table)return;
    const active=document.querySelector('.comp-tabs button.on')?.dataset.brand||'surron';
    if(active==='stark')return;
    const row=[...table.querySelectorAll('tbody tr')]
      .find(candidate=>normalize(candidate.firstElementChild?.textContent)==='precio');
    if(!row)return;
    const productIds=[22,32,33];
    [...row.children].slice(1).forEach((cell,index)=>{
      const item=catalogItemById(productIds[index]);
      if(!item)return;
      const handle=handles[String(item.id)]||item.slug;
      const apply=nativeProduct=>{
        if(!nativeProduct)return;
        const bounds=priceBounds(nativeProduct);
        const label=bounds&&bounds.max>0?labelForBounds(bounds):labelForCatalogPrice(item?.price);
        setTextIfChanged(cell,label);
      };
      const immediate=productMap[handle]||(window.ELEVENINE_NATIVE_PRODUCT?.handle===handle?window.ELEVENINE_NATIVE_PRODUCT:null);
      if(immediate)apply(immediate);
      else fetchProduct(handle).then(apply);
    });
  };

  const selectedProductOptions=()=>{
    const requestedModel=new URLSearchParams(location.search).get('modelo');
    const selections=selectionsForModel(requestedModel);
    const root=document.querySelector('[data-product-page]');
    if(!selections.Modelo){
      const lockedModel=root?.querySelector('.locked-model-generation strong')?.textContent?.trim();
      const item=window.ELEVENINE_CATALOG?.bySlug?.(window.ELEVENINE_NATIVE_PRODUCT?.handle);
      const defaultModel=String(item?.defaultSelections?.Modelo||'').trim();
      const resolvedModel=lockedModel||defaultModel;
      if(/^\d{4}$/.test(resolvedModel))selections.Modelo=resolvedModel;
    }
    root?.querySelectorAll('.variant-field[data-variant]').forEach(field=>{
      const active=field.querySelector('.variant-option.active');
      if(active)selections[field.dataset.variant]=active.dataset.value;
    });
    return selections;
  };

  const syncProductPage=()=>{
    const root=document.querySelector('[data-product-page]');
    const priceNode=root?.querySelector('.product-price');
    const nativeProduct=window.ELEVENINE_NATIVE_PRODUCT;
    const item=window.ELEVENINE_CATALOG?.bySlug?.(nativeProduct?.handle);
    if(!root||!priceNode||!nativeProduct||item?.category==='STARK VARG'||!hasPositiveShopifyPrice(nativeProduct))return;
    const bounds=priceBounds(nativeProduct,selectedProductOptions());
    const label=bounds&&bounds.max>0?labelForBounds(bounds):labelForCatalogPrice(item?.price);
    setTextIfChanged(priceNode,label);
  };

  const syncDOM=()=>{
    document.querySelectorAll('[data-product-id]').forEach(syncCard);
    document.querySelectorAll('a.product-card-mini').forEach(syncRelatedCard);
    syncComparator();
    syncProductPage();
  };

  let syncQueued=false;
  function scheduleSync(){
    if(syncQueued)return;
    syncQueued=true;
    queueMicrotask(()=>{
      syncQueued=false;
      syncDOM();
    });
  }

  hydrateCatalogData();
  syncDOM();

  document.addEventListener('click',event=>{
    if(event.target.closest('.variant-option,.comp-tabs button'))setTimeout(scheduleSync,0);
  });

  new MutationObserver(scheduleSync).observe(document.body,{childList:true,subtree:true});
})();
